import { ReactFlowInstance, Node } from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";

/**
 * Delete workflow node and all child nodes and edges
 * @param context
 * @param reactFlowInstance
 */
export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    let deleteNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditLoopNode.id)) {
            newNodes.push(node);
        } else {
            deleteNodes.push(node);
            // reactFlowInstance.deleteElements(node.id);
        }
    }

    let edges = context.edges;
    let removeEdges = [];
    let newEdges = [];
    for (const edge of edges) {
        if (edge.id.includes(context.activeEditLoopNode.id)) {
            removeEdges.push(edge);
            // reactFlowInstance.deleteElements(edge.id);
        } else {
            newEdges.push(edge);
        }
    }
    // reactFlowInstance.setEdges(newEdges);
    // reactFlowInstance.setNodes(newNodes);

    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode = context.activeEditLoopNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes = reactFlowInstance.getNodes();
    let newNodes = [];
    let activeIds = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }

    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    required: [],
    properties: {
        'data_input': {
            title: 'Data Input',
            type: 'string',
            description: 'Location of array or Data Model value to loop',
            default: 'default'
        },
        input_key: {
            title: 'Key For',
            type: 'string',
            description: 'Key for Data Input value array or Data Model, use value_one/value_two for nested data',
        },
        'data_management': {
            title: 'Data Store',
            type: 'string',
            description: 'Location to store results',
            default: 'default'
        }
    },
}

export const nodeDescription: string = "This node is used to loop through a Data Model or array and completing a set of actions.\n";